import { HttpClient, HttpEvent, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { InventoryEntryImportModel } from 'src/app/models/imports/inventory-entry-import.model';
import { InventoryEntryDetailModel } from 'src/app/models/inventory/inventory-entry-detail.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { RentalStockModel } from 'src/app/models/rental/rental-stock-response.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { ArticleSelectionTableModel } from 'src/app/models/tables/archive/article-selection-table.model';
import { ArticlesDevolutionForEntriesTableModel } from 'src/app/models/tables/inventory/articles-devolution-entries-table.model';
import { ArticlesPurchaseOrderForEntriesTableModel } from 'src/app/models/tables/inventory/articles-purchase-order-entries-table.model';
import { InventoryEntryDetailCaptureTableModel } from 'src/app/models/tables/inventory/inventory-entry-detail-capture-table.model';
import { InventoryEntryDetailTableModel } from 'src/app/models/tables/inventory/inventory-entry-detail-table.model';
import { PurchaseOrderPendingTableModel } from 'src/app/models/tables/inventory/purchase-order-pending-table.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InventoryEntryDetailService {

  constructor(private _httpClient: HttpClient) { }

  createInventoryEntryDetail(inventoryEntryDetailContractModel: InventoryEntryDetailModel): Observable<InventoryEntryDetailModel> {
    return this._httpClient.post<InventoryEntryDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntryDetail.CreateInventoryEntryDetail}`,
      inventoryEntryDetailContractModel);
  }

  deleteInventoryEntryDetail(inventoryEntryDetailId: number): Observable<InventoryEntryDetailModel> {
    return this._httpClient.delete<InventoryEntryDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntryDetail.DeleteInventoryEntryDetail}/${inventoryEntryDetailId}`);
  }

  deleteSomeDetails(inventoryEntryDetailIds: number[]): Observable<boolean> {
    return this._httpClient.put<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntryDetail.DeleteSomeDetails}`,
      inventoryEntryDetailIds);
  }

  downloadGuideImport(): Observable<HttpEvent<Blob>> {
    return this._httpClient.request(new HttpRequest('GET', `${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntryDetail.DownloadGuideImport}`,
      null, { reportProgress: true, responseType: 'blob' }));
  }

  exportDetailConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntryDetail.ExportDetailConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  exportImportErrors(alerts: PreInvoicingAlertModel[]): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntryDetail.ExportImportErrors}`, alerts,
      {
        responseType: 'blob'
      }
    );
  }

  exportPurchaseOrderPendingConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntryDetail.ExportPurchaseOrderPendingConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  getAllArticlesForEntriesForSelectAsync(providerId: number, swRequirePurchaseOrder: boolean, inventoryEntryId: number): Observable<Array<any>> {
    const params = new HttpParams().set('providerId', providerId).set('swRequirePurchaseOrder', swRequirePurchaseOrder).set('inventoryEntryId', inventoryEntryId);
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntryDetail.GetAllArticlesForEntriesForSelectAsync}`, { params });
  }

  getArticlesDevolutionForEntries(inventoryEntryId: number, page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<ArticlesDevolutionForEntriesTableModel>> {
    const params = new HttpParams().set('inventoryEntryId', inventoryEntryId).set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<ArticlesDevolutionForEntriesTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntryDetail.GetArticlesDevolutionForEntries}`,
      filters, { params: params }
    );
  }

  getArticlesForEntries(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<ArticleSelectionTableModel>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<ArticleSelectionTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntryDetail.GetArticlesForEntries}`,
      filters, { params: params }
    );
  }

  getArticlesPurchaseOrderForEntries(providerId: number, inventoryEntryId: number, page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<ArticlesPurchaseOrderForEntriesTableModel>> {
    const params = new HttpParams().set('providerId', providerId).set('inventoryEntryId', inventoryEntryId).set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<ArticlesPurchaseOrderForEntriesTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntryDetail.GetArticlesPurchaseOrderForEntries}`,
      filters, { params: params }
    );
  }

  getInventoryEntryDetailById(inventoryEntryDetailId: number): Observable<InventoryEntryDetailModel> {
    return this._httpClient.get<InventoryEntryDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntryDetail.GetInventoryEntryDetailById}/${inventoryEntryDetailId}`);
  }

  getColumnsForArticles(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntryDetail.GetColumnsForArticles}`);
  }

  getColumnsForArticlesDevolutionForEntriesAsync(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntryDetail.GetColumnsForArticlesDevolutionForEntries}`);
  }

  getColumnsForArticlesPurchaseOrderForEntriesAsync(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntryDetail.GetColumnsForArticlesPurchaseOrderForEntries}`);
  }

  getColumnsForCaptureTable(inventoryEntryTypeId: number): Observable<ColumnResponseModel[]> {
    const params = new HttpParams().set('inventoryEntryTypeId', inventoryEntryTypeId);
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntryDetail.GetColumnsForCaptureTableAsync}`, { params });
  }

  getColumnsForDetailConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntryDetail.GetColumnsForDetailConsultationAsync}`);
  }

  getColumnsForPurchaseOrderPendingConsultationAsync(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntryDetail.GetColumnsForPurchaseOrderPendingConsultation}`);
  }

  getInventoryEntryDetailByEntryId(inventoryEntryId: number): Observable<InventoryEntryDetailModel[]> {
    return this._httpClient.get<InventoryEntryDetailModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntryDetail.GetInventoryEntryDetailByEntryId}/${inventoryEntryId}`);
  }

  getInventoryEntryDetailByKeys(inventoryEntryId: number, storeId: number, articleId: number): Observable<InventoryEntryDetailModel> {
    const params = new HttpParams().set('inventoryEntryId', inventoryEntryId).set('storeId', storeId).set('articleId', articleId);
    return this._httpClient.get<InventoryEntryDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntryDetail.GetInventoryEntryDetailByKeys}`,
      { params: params }
    );
  }

  getInventoryEntryDetailsForCaptureTable(page: number, limit: number, columnSort: string | null, ascendant: boolean, inventoryEntryId: number): Observable<PagedResponseModel<InventoryEntryDetailCaptureTableModel>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant).set('inventoryEntryId', inventoryEntryId);
    return this._httpClient.get<PagedResponseModel<InventoryEntryDetailCaptureTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntryDetail.GetInventoryEntryDetailsForCaptureTable}`,
      { params: params }
    );
  }

  getInventoryEntryDetailsForDetailConsultation(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<InventoryEntryDetailTableModel>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<InventoryEntryDetailTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntryDetail.GetInventoryEntryDetailsForDetailConsultation}`,
      filters, { params: params }
    );
  }

  getPurchaseOrderPendingConsultation(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<PurchaseOrderPendingTableModel>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<PurchaseOrderPendingTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntryDetail.GetPurchaseOrderPendingConsultation}`,
      filters, { params: params }
    );
  }

  getStocksByArticleIdStoreId(rentalStockModel: RentalStockModel): Observable<number> {
    return this._httpClient.post<number>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntryDetail.GetStocksByArticleIdStoreId}`,
      rentalStockModel);
  }

  getQuantityPendingDevolutionByOrigin(inventoryEntryDetailOriginId: number): Observable<number> {
    return this._httpClient.get<number>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntryDetail.GetQuantityPendingDevolutionByOrigin}/${inventoryEntryDetailOriginId}`);
  }

  getQuantityPendingPuchaseOrderByArticle(purchaseOrderDetailId: number, articleId: number): Observable<number> {
    return this._httpClient.get<number>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntryDetail.GetQuantityPendingPuchaseOrderByArticle}/${purchaseOrderDetailId}/${articleId}`,);
  }


  importInventoryEntry(inventoryEntryImports: InventoryEntryImportModel[]): Observable<LoadPreInvoicingModel> {
    return this._httpClient.put<LoadPreInvoicingModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntryDetail.ImportInventoryEntry}`,
      inventoryEntryImports);
  }

  updateInventoryEntryDetail(inventoryEntryDetailContractModel: InventoryEntryDetailModel): Observable<InventoryEntryDetailModel> {
    return this._httpClient.put<InventoryEntryDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntryDetail.UpdateInventoryEntryDetail}`,
      inventoryEntryDetailContractModel);
  }
}
